import { Component, OnInit, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { PanelModule } from 'primeng/panel';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { NgxSpinnerService } from 'ngx-spinner';
import { StoreService } from '../store.service';
import { DialogModule } from 'primeng/dialog';


import { ApiService } from '../api.service';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService]
})
export class ProductListComponent implements OnInit {
  loadingMessage: any = "Loading...";
  public msgs: Message[] = [];
  lstProduct: any = [];

  constructor(private router: Router, private api: ApiService, private ss: StoreService,
    private http: HttpClient, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.getProduct();
  }
  getProduct() {

    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Rah/GetAllRahProduct','').subscribe(
      (res: {}) => this.successGetproduct(res),
      error => this.failedApproveDoc(<any>error));

  }
  syncProduct(){
    this.getProduct();
  }

  successGetproduct(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.lstProduct = resp.Data;
  }

  failedApproveDoc(resp: any) {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: 'Failed', detail: 'Please reconnect your company & try again...' });
    this.spinner.hide();
  }
}
